import { alphaNumericRegexMask, numericRegexMask } from "@/common/constants/masks.constant";
import { optionsToStrategy } from "@/common/utils/optionsToStrategy";
import { LucideIcon, Table2Icon, TablePropertiesIcon } from "lucide-react";

type TefProvider = {
  Icon: LucideIcon;
  label: string;
  codeLength: number;
  regexMaskFn: (length: number) => RegExp;
}

export const tefProviders: Record<string, TefProvider> = {
  fiserv: {
    Icon: Table2Icon,
    label: 'Fiserv',
    codeLength: 6,
    regexMaskFn: alphaNumericRegexMask,
  },
  linx: {
    Icon: TablePropertiesIcon,
    label: 'Linx',
    codeLength: 3,
    regexMaskFn: numericRegexMask,
  },
};

export const tefProviderOptions = Object.entries(tefProviders).map(([key, { label }]) => ({
  label,
  value: key,
}));

export const tefProvidersStrategy = optionsToStrategy(tefProviderOptions);
